import type { FC } from 'react'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import { formatPartialPhoneNumber, toPhoneDigits } from '~/shared/lib/displayText'

type PhoneNumberFieldProps = Omit<TextFieldProps, 'value' | 'onChange'> & {
  value: string | null
  onChange: (digits: string) => void
}

export const isIncompletePhoneNumber = (phoneNumber: string | null): boolean => {
  const digits = toPhoneDigits(phoneNumber)
  return digits.length > 0 && digits.length < 10
}

/** A US phone input that accepts at most ten digits and reports them without punctuation. */
const PhoneNumberField: FC<PhoneNumberFieldProps> = ({ value, onChange, ...textFieldProps }) => {
  const isIncomplete = isIncompletePhoneNumber(value)
  return (
    <TextField
      {...textFieldProps}
      type="tel"
      value={formatPartialPhoneNumber(toPhoneDigits(value))}
      onChange={event => onChange(toPhoneDigits(event.target.value))}
      error={isIncomplete}
      helperText={isIncomplete ? 'Enter a 10-digit number' : undefined}
    />
  )
}

export default PhoneNumberField
